import { c as _c } from "react/compiler-runtime";
import Link from "next/link";
import dynamic from "next/dynamic";
const ProductSearch = dynamic(() => import("@/components/product/search"), {
  ssr: false,
  loading: () => <div className="w-[349px] h-[40px] invisible"></div>
});
import UserSection from "./UserSection";
import { DesktopHeaderProps } from "./types";
import tooffiLogo from "@/assets/images/tooffi-logo.svg";
import ImageComponent from "@/components/ui/image";
import { ShoppingBag } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useCheckout } from "@/contexts/checkout";
import { useCallback, useMemo } from "react";
const DesktopHeader: React.FC<DesktopHeaderProps> = t0 => {
  const $ = _c(23);
  const {
    isAppLaunched,
    showSearchVisible,
    showCart,
    setShowSearch,
    setShowLoginState,
    isAuthenticated,
    isAuthLoading,
    showUser,
    showUserDropdown,
    setShowUserDropdown,
    handleLogout,
    isLoggingOut,
    userDropdownRef,
    mounted
  } = t0;
  const {
    products,
    setIsCartOpen
  } = useCheckout();
  const cartItemCount = products.reduce(_temp, 0);
  let t1;
  if ($[0] !== setIsCartOpen) {
    t1 = () => {
      setIsCartOpen(true);
    };
    $[0] = setIsCartOpen;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const openCart = t1;
  const t2 = `flex flex-row items-center max-w-[1440px] mx-auto w-full md:px-12 lg:px-8 px-4 ${isAppLaunched ? "justify-between pt-2 md:pt-3 lg:pt-5 " : "justify-center"}`;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="flex items-center text-[#303030]"><div className="flex flex-row items-center justify-center"><Link href="/" className="block text-5xl font-semibold font-montserrat"><ImageComponent alt="tooffi" src={tooffiLogo} className="h-9 lg:h-14 w-auto aspect-[124/47]" width={124} height={47} sizes="(max-width: 1024px) 95px, 148px" objectFit="contain" preload={true} fetchPriority="high" /></Link></div></div>;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== cartItemCount || $[4] !== handleLogout || $[5] !== isAppLaunched || $[6] !== isAuthLoading || $[7] !== isAuthenticated || $[8] !== isLoggingOut || $[9] !== mounted || $[10] !== openCart || $[11] !== setShowLoginState || $[12] !== setShowSearch || $[13] !== setShowUserDropdown || $[14] !== showCart || $[15] !== showSearchVisible || $[16] !== showUser || $[17] !== showUserDropdown || $[18] !== userDropdownRef) {
    t4 = isAppLaunched && <div className="flex items-center gap-4 flex-1 justify-end ml-4">{showSearchVisible && <ProductSearch setShowSearch={setShowSearch} />}<div className="flex items-center gap-4"><div className="flex items-center gap-4 text-[#777777]">{mounted ? <UserSection isAuthenticated={isAuthenticated} isAuthLoading={isAuthLoading} showUser={showUser} showUserDropdown={showUserDropdown} setShowUserDropdown={setShowUserDropdown} handleLogout={handleLogout} isLoggingOut={isLoggingOut} userDropdownRef={userDropdownRef} setShowLoginState={setShowLoginState} /> : <div className="w-8 h-8 rounded-full bg-gray-100" />}{showCart && <Button className="relative cursor-pointer p-0 h-auto" onClick={openCart} variant="ghost" aria-label="Open cart"><ShoppingBag size={30} />{mounted && cartItemCount > 0 && <div className="absolute -top-1 -right-2 bg-[#037A6A] text-white text-xs rounded-full w-5 h-5 flex items-center justify-center">{cartItemCount}</div>}</Button>}</div></div></div>;
    $[3] = cartItemCount;
    $[4] = handleLogout;
    $[5] = isAppLaunched;
    $[6] = isAuthLoading;
    $[7] = isAuthenticated;
    $[8] = isLoggingOut;
    $[9] = mounted;
    $[10] = openCart;
    $[11] = setShowLoginState;
    $[12] = setShowSearch;
    $[13] = setShowUserDropdown;
    $[14] = showCart;
    $[15] = showSearchVisible;
    $[16] = showUser;
    $[17] = showUserDropdown;
    $[18] = userDropdownRef;
    $[19] = t4;
  } else {
    t4 = $[19];
  }
  let t5;
  if ($[20] !== t2 || $[21] !== t4) {
    t5 = <div className="py-4 lg:py-0 bg-white hidden lg:flex flex-col lg:pointer-events-auto pointer-events-none "><div className={t2}>{t3}{t4}</div></div>;
    $[20] = t2;
    $[21] = t4;
    $[22] = t5;
  } else {
    t5 = $[22];
  }
  return t5;
};
export default DesktopHeader;
function _temp(acc, product) {
  return acc + product.count;
}